module.exports = __webpack_public_path__ + "img/close-icon.aeec2863.svg";